import { MapInteractive } from "@/modules/map";

import TreeMapFilterAssetConditionRating from "./tree-map-filter-asset-condition-rating";
import TreeMapFilterAssetState from "./tree-map-filter-asset-state";
import TreeMapFilterAssetType from "./tree-map-filter-asset-type";
import TreeMapFilterCard from "./tree-map-filter-card";
import TreeMapFilterLocation from "./tree-map-filter-location";
import { useTreeMap } from "./tree-map.context";

import "./tree-map.style.less";

const TreeMap = () => {
  const {
    markers,
    geojson,
    geojsonOptions,
    loading,
    mapId,
    subItemsDepth,
    showFilters,
  } = useTreeMap();

  return (
    <div className="tree-map">
      <MapInteractive
        id={mapId}
        markers={markers}
        geojson={geojson}
        geojsonOptions={geojsonOptions}
        loading={loading}
        sizes={{ height: "100%" }}
        subItemsDepth={subItemsDepth}
      />
      {showFilters && (
        <div className="tree-map-filters">
          <TreeMapFilterCard
            type="location"
            subFilters={<TreeMapFilterLocation />}
          />
          <TreeMapFilterCard
            type="asset"
            subFilters={
              <>
                <TreeMapFilterAssetConditionRating />
                <TreeMapFilterAssetState />
                <TreeMapFilterAssetType />
              </>
            }
          />
        </div>
      )}
    </div>
  );
};

export default TreeMap;
